export enum YesNo {
  YES = "Yes",
  NO = "No",
  Y = "Y",
  N = "N",
}
